export enum TicketMasterEnum {
  All = 0,
  MasterTicketsOnly = 1,
  TicketsWithoutMasterTickets = 2,
}

// export const ticketMasterArray = Object.keys(TicketMasterEnum)
//   .filter((key) => isNaN(Number(key))) // Filter out numeric keys
//   .map((key) => ({
//     id: TicketMasterEnum[key as keyof typeof TicketMasterEnum], // Use the enum value as the ID
//     // title: key, // Enum name as the title
//     title: key.replace(/([a-z])([A-Z])/g, "$1 $2"),
//   }));

export const ticketMasterArray = [
  { id: 1, title: "Master" },
  { id: 2, title: "Tickets" },
];
